import { render, staticRenderFns } from "./relevance-form-dropdown.vue?vue&type=template&id=f6051d16&scoped=true&"
import script from "./relevance-form-dropdown.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-dropdown.vue?vue&type=style&index=0&lang=less&"
import style1 from "./relevance-form-dropdown.vue?vue&type=style&index=1&id=f6051d16&lang=less&scoped=true&"
import style2 from "./relevance-form-dropdown.vue?vue&type=style&index=2&id=f6051d16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6051d16",
  null
  
)

export default component.exports